import React, { useEffect, useState, Fragment } from "react";
import TextArea from "../../../common/components/textArea";
import FloatingLabel from "../../../common/components/inputs/FloatingLabel";
import Utils from "../../../utility";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  getProjectDetails,
  updateProject,
  pushToMetaAd,
  getFacebookStatus,
  getMetaAdAccounts
} from "../../../services/userService";
import Header from "../../../common/components/header";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../../slices/userSlice";

function FinalReview() {
  const [user] = useState(JSON.parse(localStorage.getItem("userDetails")));
  // eslint-disable-next-line no-unused-vars
  const brandDetails = useSelector((state) => state?.user?.brandDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUrl = window.location.href;

  const projectTemplateIds = currentUrl.split("/");

  const [projectDetails, setProjectDetails] = useState({});
  const [platformName, setPlatformName] = useState();
  const [manage, setManage] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [templateId, setTemplateId] = useState("");
  const primaryTextArr = projectDetails?.generatedData?.primaryText ?? [];

  // Selection state for Meta ad push
  const [selectedPrimaryTextIndex, setSelectedPrimaryTextIndex] =
    useState(null);
  const [selectedHeadlineIndex, setSelectedHeadlineIndex] = useState(null);
  const [selectedDescriptionIndex, setSelectedDescriptionIndex] =
    useState(null);
  const [facebookConnected, setFacebookConnected] = useState(false);
  const [isPushingToMeta, setIsPushingToMeta] = useState(false);
  const [metaAdAccounts, setMetaAdAccounts] = useState([]);
  const [selectedAdAccountId, setSelectedAdAccountId] = useState(null);
  const [loadingAdAccounts, setLoadingAdAccounts] = useState(false);
  const [showAdAccountModal, setShowAdAccountModal] = useState(false);
  const handleGetProjectDetails = async (projectId) => {
    try {
      dispatch(showLoader());
      const [error, response] = await Utils.parseResponse(
        getProjectDetails(projectId)
      );

      if (error || !response) {
        toast.error("Error");
        return;
      }

      setProjectDetails(response?.responseData);
      setPlatformName(response?.responseData?.platformName);
    } catch (err) {
      console.error("An error occurred while fetching project details:", err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleProjectUpdate = async () => {
    if (
      projectDetails?.generatedData?.primaryText !== null &&
      (projectDetails?.generatedData?.primaryText[0] ||
        projectDetails?.generatedData?.primaryText[0]?.length === 0) &&
      projectDetails?.generatedData?.primaryText[0]?.length < 10
    ) {
      Utils.failureToastMessage(
        "Minimum 10 characters is required for primary text"
      );
      return;
    }
    if (projectDetails.projectDescription?.length < 10) {
      Utils.failureToastMessage(
        "Minimum 10 characters is required for description"
      );
      return;
    }
    if (
      (projectDetails?.generatedData?.headlines[0] ||
        projectDetails?.generatedData?.headlines[0]?.length === 0) &&
      projectDetails?.generatedData?.headlines[0]?.length < 10
    ) {
      Utils.failureToastMessage(
        "Minimum 10 characters is required for headlines"
      );
      return;
    }
    if (
      (projectDetails?.generatedData?.headlines[1] ||
        projectDetails?.generatedData?.headlines[1]?.length === 0) &&
      projectDetails?.generatedData?.headlines[1]?.length < 10
    ) {
      Utils.failureToastMessage(
        "Minimum 10 characters is required for headlines"
      );
      return;
    }
    if (
      (projectDetails?.generatedData?.headlines[2] ||
        projectDetails?.generatedData?.headlines[2]?.length === 0) &&
      projectDetails?.generatedData?.headlines[2]?.length < 10
    ) {
      Utils.failureToastMessage(
        "Minimum 10 characters is required for headlines"
      );
      return;
    }

    try {
      dispatch(showLoader());
      // CRITICAL: Only send fields that need to be updated to avoid 413 error
      // Spreading entire projectDetails causes "Content Too Large" error
      let data = {
        isDraft: false,
        generatedData: projectDetails?.generatedData,
        projectName: projectDetails?.projectName,
        projectDescription: projectDetails?.projectDescription
      };
      // eslint-disable-next-line no-unused-vars
      const [error, response] = await Utils.parseResponse(
        updateProject(projectTemplateIds[8], data)
      );
      if (error) {
        if (error?.response?.data?.message) {
          Utils.failureToastMessage(error?.response?.data?.message);
          return;
        } else {
          Utils.failureToastMessage("Some error occured");
          return;
        }
      } else {
        await handleGetProjectDetails(projectTemplateIds[8]);
        Utils.successToastMessage("Project Updated Successfully");
        navigate(`/dashboard/brand/details/${projectDetails?.brandId?._id}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };
  const redirectBackToEditor = () => {
    navigate(`/editor/${projectTemplateIds[9]}/${projectTemplateIds[8]}`);
  };
  const redirectToPage = () => {
    // navigate(`/editor/${projectTemplateIds[9]}/${projectTemplateIds[8]}`);
    if (
      projectDetails?.images?.length == 0 &&
      projectDetails?.selectedImage &&
      !projectDetails?.createdAdJson
      // projectDetails?.isDraft
    ) {
      navigate(
        `/dashboard/brand/details/${projectDetails?.brandId?._id}/${projectTemplateIds[8]}`
      );
    } else if (
      projectDetails?.selectedImage &&
      projectDetails?.createdAdJson
      // projectDetails?.isDraft
    ) {
      navigate(
        `/editor/${projectDetails?.selectedTemplateId}/${projectTemplateIds[8]}`
      );
    } else if (
      projectDetails?.images?.length > 0 &&
      !projectDetails?.selectedImage &&
      !projectDetails?.createdAdJson
      // projectDetails?.isDraft
    ) {
      navigate(
        `/dashboard/brand/details/${projectDetails?.brandId?._id}/true/${projectTemplateIds[8]}`
      );
    } else if (
      projectDetails?.images?.length > 0 &&
      projectDetails?.selectedImage &&
      !projectDetails?.createdAdJson
      // projectDetails?.isDraft
    ) {
      navigate(
        `/dashboard/brand/details/${projectDetails?.brandId?._id}/${projectTemplateIds[8]}`
      );
    }

    // setStep(4);
  };
  // Fetch Meta ad accounts
  const fetchMetaAdAccounts = async (facebookToken) => {
    try {
      setLoadingAdAccounts(true);
      const [error, response] = await Utils.parseResponse(
        getMetaAdAccounts(facebookToken)
      );
      if (!error && response?.responseData?.accounts) {
        const accounts = response.responseData.accounts;
        setMetaAdAccounts(accounts);
        return accounts; // Return accounts for immediate use
      } else if (error) {
        console.error("Error fetching ad accounts:", error);
        setMetaAdAccounts([]);
        return [];
      }
      return [];
    } catch (err) {
      console.error("Error fetching ad accounts:", err);
      setMetaAdAccounts([]);
      return [];
    } finally {
      setLoadingAdAccounts(false);
    }
  };

  // Check Facebook connection status
  const checkFacebookConnection = async () => {
    try {
      const [error, response] = await Utils.parseResponse(getFacebookStatus());
      if (!error && response?.responseData) {
        const isConnected = response.responseData.facebookConnected || false;
        setFacebookConnected(isConnected);
        console.log("Facebook connection status:", {
          connected: isConnected,
          hasToken: !!response.responseData.facebookTokens?.accessToken
        });

        // Don't fetch ad accounts automatically - will fetch when button is clicked
      } else if (error) {
        console.error("Error checking Facebook status:", error);
        setFacebookConnected(false);
      }
    } catch (err) {
      console.error("Error checking Facebook status:", err);
      setFacebookConnected(false);
    }
  };

  // Handle push to Meta button click - show ad account selection modal
  const handlePushToMetaClick = async () => {
    // Validate selections
    if (
      selectedPrimaryTextIndex === null ||
      selectedHeadlineIndex === null ||
      selectedDescriptionIndex === null
    ) {
      Utils.failureToastMessage(
        "Please select one primary text, one headline, and one description"
      );
      return;
    }

    // Check Facebook connection
    if (!facebookConnected) {
      Utils.failureToastMessage(
        "Please connect your Facebook account in Settings first"
      );
      return;
    }

    // Validate image
    const imageUrl =
      projectDetails?.selectedImage || projectDetails?.createdImage;
    if (!imageUrl) {
      Utils.failureToastMessage("Please select an image for the ad");
      return;
    }

    // Get Facebook token and fetch ad accounts
    try {
      setLoadingAdAccounts(true);
      let facebookToken = null;
      const [fbError, fbResponse] =
        await Utils.parseResponse(getFacebookStatus());
      if (
        !fbError &&
        fbResponse?.responseData?.facebookConnected &&
        fbResponse?.responseData?.facebookTokens?.accessToken
      ) {
        facebookToken = fbResponse.responseData.facebookTokens.accessToken;
      }

      // Fetch ad accounts
      const accounts = await fetchMetaAdAccounts(facebookToken);
      const activeAccounts = accounts.filter((acc) => acc.account_status === 1);

      // Show modal with ad accounts
      if (activeAccounts.length > 0) {
        setShowAdAccountModal(true);
      } else {
        Utils.failureToastMessage(
          "No active ad accounts found. Please add an ad account in Meta Business Manager."
        );
      }
    } catch (err) {
      console.error("Error fetching ad accounts:", err);
      Utils.failureToastMessage(
        "Failed to fetch ad accounts. Please try again."
      );
    } finally {
      setLoadingAdAccounts(false);
    }
  };

  // Actually push ad to Meta after account selection
  const handlePushToMeta = async () => {
    if (!selectedAdAccountId) {
      Utils.failureToastMessage("Please select an ad account");
      return;
    }

    try {
      setIsPushingToMeta(true);
      dispatch(showLoader());
      setShowAdAccountModal(false); // Close modal

      // Get Facebook token for API call
      let facebookToken = null;
      try {
        const [fbError, fbResponse] =
          await Utils.parseResponse(getFacebookStatus());
        if (
          !fbError &&
          fbResponse?.responseData?.facebookConnected &&
          fbResponse?.responseData?.facebookTokens?.accessToken
        ) {
          facebookToken = fbResponse.responseData.facebookTokens.accessToken;
        }
      } catch (err) {
        console.error("Error getting Facebook token:", err);
      }

      const imageUrl =
        projectDetails?.selectedImage || projectDetails?.createdImage;

      const payload = {
        selectedContent: {
          primaryText:
            projectDetails.generatedData.primaryText[selectedPrimaryTextIndex],
          headline:
            projectDetails.generatedData.headlines[selectedHeadlineIndex],
          description:
            projectDetails.generatedData.description[selectedDescriptionIndex],
          imageUrl: imageUrl
        },
        projectName: projectDetails.projectName,
        projectGoal: projectDetails.projectGoal,
        targetAudience: projectDetails.targetAudience,
        facebookAccessToken: facebookToken,
        adAccountId: selectedAdAccountId
      };

      const [error, response] = await Utils.parseResponse(
        pushToMetaAd(projectTemplateIds[8], payload)
      );

      if (error) {
        if (error?.response?.data?.message) {
          Utils.failureToastMessage(error.response.data.message);
        } else if (
          error?.message?.includes("token") ||
          error?.message?.includes("expired")
        ) {
          Utils.failureToastMessage(
            "Facebook connection expired. Please reconnect in Settings."
          );
        } else if (error?.message?.includes("permission")) {
          Utils.failureToastMessage(
            "Missing required permissions. Please reconnect Facebook with ad management access."
          );
        } else {
          Utils.failureToastMessage(
            "Failed to push ad to Meta. Please try again."
          );
        }
        return;
      }

      if (response && response.responseData) {
        Utils.successToastMessage(
          "Ad pushed to Meta, Now you can go to your Ad account and set the ad live"
        );
        // Reset selected account
        setSelectedAdAccountId(null);
        // Optionally refresh project details to get Meta IDs
        await handleGetProjectDetails(projectTemplateIds[8]);
      }
    } catch (error) {
      console.error("Error pushing to Meta:", error);
      Utils.failureToastMessage("Failed to connect to Meta. Please try again.");
    } finally {
      setIsPushingToMeta(false);
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    if (projectTemplateIds) {
      handleGetProjectDetails(projectTemplateIds[8]);
      if (projectTemplateIds[9]) {
        setTemplateId(projectTemplateIds[9]);
      }
    }
    // Check Facebook connection for Meta/Instagram projects
    if (
      platformName === "Facebook" ||
      platformName === "Instagram" ||
      projectDetails?.platformName === "Facebook" ||
      projectDetails?.platformName === "Instagram"
    ) {
      checkFacebookConnection();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformName, projectDetails?.platformName]);

  // FUNCTION TO DOWNLOAD CREATED IMAGE
  // const downloadImage = () => {
  //   const imageUrl =
  //     projectDetails?.createdImage || projectDetails?.selectedImage;

  //   if (imageUrl) {
  //     const link = document.createElement("a");
  //     link.href = imageUrl;
  //     link.download = "image.jpg";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } else {
  //     console.error("No image available to download");
  //   }
  // };

  return (
    <>
      <div
        className="pb-27.2"
        style={{
          background:
            "linear-gradient(180deg, #021327 0%, #04264E 0.01%, #000000 100%)",
          marginLeft: 32,
          marginRight: 32,
          marginTop: 20,
          borderRadius: 16
        }}
      >
        <Header
          user={user}
          navigate={navigate}
          brandDetails={false}
          setNavigate={(item) =>
            navigate(`/dashboard/brand/details/${item?.id}`)
          }
          dropdown={false}
          setDropdown={() => {}}
          manage={manage}
          setManage={setManage}
          pathname={""}
          query={""}
          setQuery={() => {}}
          setLoading={() => {}}
        />
      </div>
      <div className="z-20 -mt-61px ml-7.7 w-[95.5%] px-8">
        <div
          style={{
            background:
              "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)",
            height: 116,
            width: "100%",
            borderRadius: 16,
            boxShadow: "0px 2px 5.5px 0px #00000005",
            padding: "20px 54px 20px 32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backdropFilter: "blur(8px)"
          }}
        >
          <div className="flex items-center">
            <div className={`flex size-81px justify-center`}>
              <>
                {brandDetails && brandDetails?.theme?.logo != " " ? (
                  <img
                    src={brandDetails?.theme?.logo}
                    alt="logo"
                    className="size-auto rounded-xl"
                  />
                ) : (
                  <div className="flex size-full items-center justify-center rounded-xl bg-green-12 font-InterBold text-ft36-40 text-white">
                    {brandDetails?.brandName?.charAt(0)?.toUpperCase()}
                  </div>
                )}
              </>
            </div>

            <div className="ml-7 flex h-auto flex-col">
              <span
                className={` font-InterBold text-ft24-32 ${brandDetails ? "text-black-9" : "text-grey-16"}`}
              >
                {brandDetails?.brandName && (
                  <Fragment>
                    <div className="w-52 truncate">
                      <span>{brandDetails?.brandName}</span>
                    </div>
                  </Fragment>
                )}
              </span>
              <span className=" mb-2 mt-1 font-InterRegular text-ft14-19.6 text-grey-22">
                {brandDetails?.businessType && (
                  <Fragment>
                    {brandDetails?.businessType || "No email found"}
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-9 mt-10 h-full bg-grey-18">
        <div className="relative size-full h-[795px] max-w-[997px] rounded-2xl bg-white p-10 pl-16">
          <div className="h-157.5 overflow-y-auto">
            <div className="flex  flex-col">
              <div className=" font-InterBold text-ft24-32 text-[#A0AEC0]">
                {`${platformName}  ${projectDetails?.projectType === "socialPost" ? "Social Post" : projectDetails?.projectType}`}
              </div>
              <div className=" font-Inter text-ft16-19.36 text-[#A0AEC0]">
                {` ${projectDetails?.projectName}`}
              </div>
            </div>
            <div className="flex">
              <div>
                <div className=" mt-6">
                  {primaryTextArr?.map((txt, index) => {
                    return (
                      <div
                        className={`mt-7 flex items-start gap-3 ${
                          selectedPrimaryTextIndex === index
                            ? "rounded-lg border-2 border-green-12 p-2"
                            : ""
                        }`}
                        key={index}
                      >
                        <input
                          type="radio"
                          name="primaryTextSelection"
                          checked={selectedPrimaryTextIndex === index}
                          onChange={() => setSelectedPrimaryTextIndex(index)}
                          className="mt-2 size-4 cursor-pointer"
                          style={{ accentColor: "#10B981" }}
                        />
                        <div className="flex-1">
                          <TextArea
                            key={index.toString()}
                            name={"primaryText"}
                            label={"Primary Text"}
                            height={"h-25.7"}
                            width={"w-175.7"}
                            value={
                              projectDetails.generatedData.primaryText[index]
                            }
                            onChange={(e) => {
                              const newValue = e.target.value;

                              // if (
                              //   newValue.length >= 10 ||
                              //   projectDetails?.generatedData?.primaryText[index]
                              //     ?.length >= 10
                              // ) {
                              setProjectDetails((preState) => ({
                                ...preState,
                                generatedData: {
                                  ...preState.generatedData,
                                  primaryText:
                                    preState.generatedData.primaryText?.map(
                                      (text, idx) =>
                                        idx === index ? newValue : text
                                    )
                                }
                              }));
                              // }
                            }}
                            haveStar={true}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>

                {projectDetails?.generatedData?.headlines?.map((txt, index) => {
                  return (
                    <div
                      className={`mt-6 flex items-start gap-3 ${
                        selectedHeadlineIndex === index
                          ? "rounded-lg border-2 border-green-12 p-2"
                          : ""
                      }`}
                      key={index.toString()}
                    >
                      <input
                        type="radio"
                        name="headlineSelection"
                        checked={selectedHeadlineIndex === index}
                        onChange={() => setSelectedHeadlineIndex(index)}
                        className="mt-2 size-4 cursor-pointer"
                        style={{ accentColor: "#10B981" }}
                      />
                      <div className="flex-1">
                        <FloatingLabel
                          name={"headline"}
                          label={"Headline"}
                          onBoard={true}
                          isStar={true}
                          isSmall={true}
                          height={"h-11.2"}
                          width={"w-175.7"}
                          isInfo={false}
                          isTool={true}
                          value={
                            projectDetails?.generatedData?.headlines[index]
                          }
                          onChange={(e) => {
                            const newValue = e.target.value;

                            // if (
                            //   newValue.length >= 10 ||
                            //   projectDetails?.generatedData?.headlines[index]
                            //     ?.length >= 10
                            // ) {
                            setProjectDetails((preState) => ({
                              ...preState,
                              generatedData: {
                                ...preState.generatedData,
                                headlines:
                                  preState.generatedData.headlines?.map(
                                    (text, idx) =>
                                      idx === index ? newValue : text
                                  )
                              }
                            }));
                            // }
                          }}
                        />
                      </div>
                    </div>
                  );
                })}

                {projectDetails?.generatedData?.description?.map(
                  (txt, index) => {
                    return (
                      <div
                        className={`mt-6 flex items-start gap-3 ${
                          selectedDescriptionIndex === index
                            ? "rounded-lg border-2 border-green-12 p-2"
                            : ""
                        }`}
                        key={index.toString()}
                      >
                        <input
                          type="radio"
                          name="descriptionSelection"
                          checked={selectedDescriptionIndex === index}
                          onChange={() => setSelectedDescriptionIndex(index)}
                          className="mt-2 size-4 cursor-pointer"
                          style={{ accentColor: "#10B981" }}
                        />
                        <div className="flex-1">
                          <TextArea
                            name={"description"}
                            label={"Description"}
                            height={
                              projectDetails?.platformName !== "Google" &&
                              projectDetails?.platformName !== "Bing"
                                ? "h-25.7"
                                : "h-65"
                            }
                            width={"w-175.7"}
                            value={
                              projectDetails?.generatedData?.description[index]
                            }
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setProjectDetails((preState) => ({
                                ...preState,
                                generatedData: {
                                  ...preState.generatedData,
                                  description:
                                    preState.generatedData.description?.map(
                                      (text, idx) =>
                                        idx === index ? newValue : text
                                    )
                                }
                              }));
                            }}
                            haveStar={true}
                          />
                        </div>
                      </div>
                    );
                  }
                )}
                <div
                  className={`${projectDetails?.platformName === "Google" || projectDetails?.platformName === "Bing" ? "hidden" : "block"} mt-6`}
                >
                  <span className="text-[#A0AEC0]">Media Asset</span>
                  {(() => {
                    console.log("🖼️ FinalReview Image Debug:", {
                      hasCreatedImage: !!projectDetails?.createdImage,
                      createdImage: projectDetails?.createdImage,
                      hasSelectedImage: !!projectDetails?.selectedImage,
                      selectedImage: projectDetails?.selectedImage,
                      displayingImage:
                        projectDetails?.createdImage ||
                        projectDetails?.selectedImage
                    });
                    return null;
                  })()}
                  {projectDetails?.createdImage ||
                  projectDetails?.selectedImage ? (
                    <img
                      className="mt-6 h-79.2 w-97 rounded-lg bg-grey-18 object-contain"
                      src={
                        projectDetails?.createdImage ||
                        projectDetails?.selectedImage
                      }
                    />
                  ) : (
                    <div className=" grid h-79.2 w-97 p-2">
                      {projectDetails?.images && (
                        <div className=" grid h-79.2 w-full grid-cols-2 gap-2 p-2 opacity-30">
                          {projectDetails.images.map((url, i) => (
                            <img
                              key={i}
                              className="h-46.2 w-full rounded object-cover"
                              src={url}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* {projectDetails?.platformName !== "Google" &&
          projectDetails?.platformName !== "Bing" &&
          (!projectDetails?.selectedImage ||
            projectDetails?.createdAdJson === undefined) ? (
            <div className="mt-7 font-InterBold text-ft16-19.36 text-grey-14">
              You have an unfinished project. Press the edit button to continue
              working on it
            </div>
          ) : null} */}
          <div className="absolute bottom-33px left-63px flex w-full items-center gap-x-10">
            <div
              className=" mt-7 flex h-8.7 w-37.5 cursor-pointer items-center justify-center rounded-3xl border-2 border-grey-14 bg-transparent px-2 font-InterBold text-ft14-19.6 text-grey-14"
              onClick={() => {
                projectTemplateIds[9] && projectDetails?.isDraft
                  ? redirectBackToEditor()
                  : navigate(
                      `/dashboard/brand/details/${projectDetails?.brandId?._id}`
                    );
              }}
            >
              BACK
            </div>
            {/* {projectDetails?.platformName !== "Google" &&
            projectDetails?.platformName !== "Bing" &&
            (projectDetails?.createdAdJson !== undefined ||
              projectDetails?.isDraft ||
              !projectDetails?.selectedImage) ? (
              <div
                onClick={redirectToPage}
                className={`mt-7 ${!projectDetails?.isDraft ? "hidden" : "flex"} h-8.7 w-37.5 cursor-pointer items-center justify-center rounded-3xl border-2 border-grey-14 bg-transparent px-2 font-InterBold text-ft14-19.6 text-grey-14`}
              >
                EDIT
              </div>
            ) : null} */}

            {projectDetails?.platformName !== "Google" &&
            projectDetails?.platformName !== "Bing" &&
            !(projectDetails?.selectedImage || "").includes(
              "gptimage2_genAIImage_"
            ) ? (
              <div
                onClick={redirectToPage}
                className={`mt-7 flex h-8.7 w-37.5 cursor-pointer items-center justify-center rounded-3xl border-2 border-grey-14 bg-transparent px-2 font-InterBold text-ft14-19.6 text-grey-14`}
              >
                EDIT
              </div>
            ) : null}

            {/* Push to Meta button - only for Facebook/Instagram */}
            {(projectDetails?.platformName === "Facebook" ||
              projectDetails?.platformName === "Instagram") && (
              <div
                className={`mt-7 flex h-8.7 w-37.5 cursor-pointer items-center justify-center rounded-3xl border-2 px-2 font-InterBold text-ft14-19.6 ${
                  selectedPrimaryTextIndex !== null &&
                  selectedHeadlineIndex !== null &&
                  selectedDescriptionIndex !== null &&
                  facebookConnected &&
                  !isPushingToMeta &&
                  !loadingAdAccounts
                    ? "border-green-12 bg-green-12 text-white"
                    : "cursor-not-allowed border-grey-14 bg-transparent text-grey-14 opacity-50"
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    selectedPrimaryTextIndex !== null &&
                    selectedHeadlineIndex !== null &&
                    selectedDescriptionIndex !== null &&
                    facebookConnected &&
                    !isPushingToMeta &&
                    !loadingAdAccounts
                  ) {
                    handlePushToMetaClick();
                  } else if (!facebookConnected) {
                    Utils.failureToastMessage(
                      "Please connect your Facebook account in Settings first"
                    );
                  }
                }}
              >
                {isPushingToMeta
                  ? "PUSHING..."
                  : loadingAdAccounts
                    ? "LOADING..."
                    : "PUSH TO META"}
              </div>
            )}

            {/* Ad Account Selection Modal */}
            {showAdAccountModal && (
              <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
                <div className="w-96 rounded-lg bg-white p-6 shadow-xl">
                  <h2 className="text-xl text-gray-800 mb-4 font-bold">
                    Select Ad Account
                  </h2>
                  <p className="text-sm text-gray-600 mb-4">
                    Choose the ad account where you want to push this ad:
                  </p>
                  <div className="mb-4">
                    <select
                      value={selectedAdAccountId || ""}
                      onChange={(e) => setSelectedAdAccountId(e.target.value)}
                      className="border-gray-300 text-sm w-full rounded-lg border-2 bg-white p-3 focus:border-green-12 focus:outline-none"
                    >
                      <option value="">Select an account</option>
                      {metaAdAccounts
                        .filter((acc) => acc.account_status === 1)
                        .map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.name} ({account.currency}) -{" "}
                            {account.statusDescription}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="flex justify-end gap-3">
                    <button
                      onClick={() => {
                        setShowAdAccountModal(false);
                        setSelectedAdAccountId(null);
                      }}
                      className="border-gray-300 text-sm text-gray-700 hover:bg-gray-50 rounded-lg border-2 bg-white px-4 py-2 font-semibold"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handlePushToMeta}
                      disabled={!selectedAdAccountId || isPushingToMeta}
                      className={`text-sm rounded-lg px-4 py-2 font-semibold text-white ${
                        selectedAdAccountId && !isPushingToMeta
                          ? "hover:bg-green-600 bg-green-12"
                          : "bg-gray-400 cursor-not-allowed"
                      }`}
                    >
                      {isPushingToMeta ? "Pushing..." : "Push Ad"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div
              className="mt-7 flex h-8.7 w-75 cursor-pointer items-center justify-center rounded-3xl bg-green-12 px-2 font-InterBold text-ft14-19.6 text-white"
              onClick={(e) => {
                e.preventDefault();
                handleProjectUpdate();
              }}
            >
              FINISH
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FinalReview;
